import { render, staticRenderFns } from "./payResult.vue?vue&type=template&id=1320613e&scoped=true&"
import script from "./payResult.vue?vue&type=script&lang=js&"
export * from "./payResult.vue?vue&type=script&lang=js&"
import style0 from "./payResult.vue?vue&type=style&index=0&id=1320613e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320613e",
  null
  
)

export default component.exports